<template>
  <table-list-page
    :board-slug="boardSlug"
    route-c="write|approval_tab_create|safety_check"
    route-u="write|approval_tab_update|safety_check"

    download="사고보고"
    :create="false"
    :approval="false"
    :move-project="true"

    :nav="nav"
    :heads="heads"
    :getCol="getCol"
  >
    <template #search>
      <search-nav-start-end class="mr-2" label="대상기간" v-model="nav.date"/>
      <search-nav-item-project :label="$t('search.사무소명')" size="normal" v-model="nav.projectId"/>
    </template>
  </table-list-page>
</template>

<script>
import TableListPage from '@/views/list/TableListPage'
import SearchNavItemSelect from '@/views/components/nav/SearchNavItemSelect'
import SearchNavStartEnd from '@/views/list/components/SearchNavStartEnd'
import SearchNavItemProject from '@/views/components/nav/SearchNavItemProject'
export default {
  name: 'RiskCheckList',
  components: {
    SearchNavItemProject,
    SearchNavStartEnd,
    SearchNavItemSelect,
    TableListPage},
  data () {
    return {
      nav: {
        projectId: 0,
        orderTarget: 'created_at',
        orderDirection: 'desc',
        date: {},
        dateTarget: ['content$body.safetyCheckBasicInfo.created_at'],
        dateBegin: ['nav.date.sDate'],
        dateEnd: ['nav.date.eDate'],
        keyword: []
      },
      heads: [
        {name: '사무소명'},
        {name: '작성자'},
        {name: '작성일'},
        {name: '안전보건담당자'},
        {name: '대상월'},
        {name: '발주공사현장'}
      ]
    }
  },
  computed: {
    boardSlug () {
      return this.$route.params.boardSlug
    }
  },
  created () {
    let boardName = ''
    if (this.boardSlug === 'firefighting_self_check') boardName = '소방시설 자체 점검결과'
    if (this.boardSlug === 'electrical_equipment_check') boardName = '전기시설 점검'
    if (this.boardSlug === 'gas_pressure_check') boardName = '가스 압력상태 점검'
    if (this.boardSlug === 'elevator_safety_check') boardName = '승강기 안전 점검'
    if (this.boardSlug === 'water_tank_hygiene_check') boardName = '저수조 위생 점검'
    if (this.boardSlug === 'periodic_safety_check_building') boardName = '정기안전점검(건축물)'

    const breadcrumb = [
      {title: 'Home'},
      {title: '안전점검'},
      {title: '안전점검'},
      {
        title: boardName,
        active: true
      }
    ]

    this.$store.commit('menu/UPDATE_PAGE_LIST', breadcrumb)
  },
  methods:{
    getCol (index, value) {
      switch (index) {
      case 0: return value.post.project.client.com_name
      case 1: return value.post.author.name
      case 2: return value.created_at
      case 3: return ''
      case 4: return this.getHeader(value).month
      case 5: return ''
      }
    },
    getContent (data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.body
      }
    },
    getHeader (data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.header
      }
    },

    addComma (str) {
      str = `${str}`
      if (str && str.length > 0) {
        return str.replace(/,/gi, '').replace(/\B(?=(\d{3})+(?!\d))/gi, ',')
      }
    }
  }
}
</script>

<style scoped>

</style>
